import { render } from "./CommissionDetailSection.vue?vue&type=template&id=15095b2b&scoped=true"
import script from "./CommissionDetailSection.vue?vue&type=script&lang=js"
export * from "./CommissionDetailSection.vue?vue&type=script&lang=js"

import "./CommissionDetailSection.vue?vue&type=style&index=0&id=15095b2b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15095b2b"]])

export default __exports__